export default "__VITE_PUBLIC_ASSET__dd1ce8a1__"